module.exports = __webpack_public_path__ + "static/media/prod-peculio.bbdca4a9.png";